const map = {
	"./carousel2_controller.js": 5477,
	"./culture_controller.js": 3931,
	"./header_controller.js": 3472,
	"./home_controller.js": 3954,
	"./home_ie11_controller.js": 8121,
	"./main_controller.js": 7752,
	"./publications_controller.js": 3334,
	"./scroll_controller.js": 1496,
	"./scroll_ie11_controller.js": 1847,
	"./service_controller.js": 444,
	"controllers/carousel2_controller.js": 5477,
	"controllers/culture_controller.js": 3931,
	"controllers/header_controller.js": 3472,
	"controllers/home_controller.js": 3954,
	"controllers/home_ie11_controller.js": 8121,
	"controllers/main_controller.js": 7752,
	"controllers/publications_controller.js": 3334,
	"controllers/scroll_controller.js": 1496,
	"controllers/scroll_ie11_controller.js": 1847,
	"controllers/service_controller.js": 444
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8887;